<template>
  <div
    :class="
      isLoginPage || isRegisterPage ? 'login-lng-dropdown' : 'language-dropdown'
    "
  >
    <v-menu offset-y v-model="isMenuOpen">
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          style="display: flex; align-items: center"
        >
          <span
            v-if="isLoginPage || isRegisterPage"
            class="lang-icon"
            v-html="loginLangSvg"
          />
          <!--          <img-->
          <!--            v-if="isLoginPage || isRegisterPage"-->
          <!--            src="@/assets/login-lang-icon.svg"-->
          <!--            alt="Language"-->
          <!--            class="lang-icon"-->
          <!--          />-->
          <TextField
            v-else
            tag="span"
            weight="500"
            hoverColor="#0056b3"
            :enableHover="true"
            style="cursor: pointer; display: inline-block"
          >
            {{ currentLanguage }}
          </TextField>
        </div>
      </template>
      <v-list>
        <v-list-item-group v-model="model" color="indigo">
          <v-list-item
            v-for="language in languages"
            :key="language.code"
            @click="selectLanguage(language)"
          >
            <v-list-item-title>{{ language.name }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <span
      v-if="!isLoginPage && !isRegisterPage"
      :class="{ 'rotate-icon': isMenuOpen }"
      v-html="dropdownSvg"
    />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import dropdownSvg from "!!raw-loader!@/assets/dropdown-icon.svg";
import loginLangSvg from "!!raw-loader!@/assets/login-lang-icon.svg";

export default {
  props: {
    languages: {
      type: Array,
    },
    defaultLanguage: {
      type: String,
    },
  },
  data() {
    return {
      model: 0,
      isMenuOpen: false,
      currentLanguage: "",
      isLoginPage: false,
      isRegisterPage: false,
      dropdownSvg,
      loginLangSvg,
    };
  },
  mounted() {
    this.isLoginPage = this.$route.path === "/login";
    this.isRegisterPage = this.$route.path === "/registration";

    const savedLanguageCode =
      Cookies.get("zk_lng") || localStorage.getItem("zk_lng");

    let languageCodeToUse = savedLanguageCode;

    if (!languageCodeToUse) {
      const browserLang = navigator.language.slice(0, 2);
      const found = this.languages.find((l) => l.code === browserLang);
      languageCodeToUse = found ? browserLang : this.defaultLanguage;
    }

    this.setLanguageByCode(languageCodeToUse, false);
  },
  methods: {
    setLanguageByCode(languageCode, reload = true) {
      const language = this.languages.find(
        (lang) => lang.code === languageCode
      );
      if (language) {
        Cookies.set("zk_lng", language.code, { path: "/", expires: 365 });

        if (reload) {
          window.location.reload();
        } else {
          this.currentLanguage = language.name;
          this.model = this.languages.indexOf(language);
          this.$i18n.locale = language.code;
        }
      }
    },
    selectLanguage(language) {
      const currentLanguageCode = Cookies.get("zk_lng");
      if (language.code !== currentLanguageCode) {
        this.setLanguageByCode(language.code);
      }
      this.isMenuOpen = false;
    },
  },
};
</script>

<style scoped>
::v-deep.language-dropdown span svg {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  transition: transform 0.3s ease;
  display: inline-block;
}

::v-deep.login-lng-dropdown span svg {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  transition: transform 0.3s ease;
  display: inline-block;
}

::v-deep .rotate-icon svg {
  transform: rotate(180deg);
}
.language-dropdown {
  width: 89px !important;
}
.login-lng-dropdown {
  display: flex;
  align-items: center;
}
</style>
